import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { CmsService } from '@spartacus/core';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-need-assistance',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './need-assistance.component.html',
    standalone: false
})
export class NeedAssistanceComponent implements OnInit, OnDestroy {
  cmsContent: any;
  compSub: Subscription;

  constructor(
    private readonly cmsData: CmsService,
    private readonly cd: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.compSub = this.cmsData
      .getComponentData('NeedAssistanceComponent')
      .subscribe((res) => {
        let needAssistanceContent: any = JSON.parse(JSON.stringify(res));
        this.cmsContent = needAssistanceContent.content;
        this.cd.detectChanges();
      });
  }

  ngOnDestroy(): void {
    this.compSub?.unsubscribe();
  }
}
